module.exports = __webpack_public_path__ + "img/store-icon-29-29px.7fa0e864.png";